import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FolderFilledIcon = function FolderFilledIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FolderFilledIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      d: "M3.059 2c-.527 0-1.043.194-1.433.557A1.94 1.94 0 0 0 1 3.977v8.046c0 .546.234 1.055.626 1.42.39.363.906.557 1.433.557h9.882c.527 0 1.043-.194 1.433-.557a1.94 1.94 0 0 0 .626-1.42V5.701a1.94 1.94 0 0 0-.626-1.42 2.1 2.1 0 0 0-1.433-.557H7.804l-.989-1.38A.82.82 0 0 0 6.147 2z"
    })
  }));
};

export { FolderFilledIcon };
